import React, { useState } from "react";
import { useParams } from "react-router-dom";

// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
import InputAdornment from "@material-ui/core/InputAdornment";
import Typography from "@material-ui/core/Typography";
import Box from "@material-ui/core/Box";
import Icon from "@material-ui/core/Icon";

// @material-ui/icons
import Lock from "@material-ui/icons/Lock";

// core components
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import Button from "components/CustomButtons/Button.js";
import Input from "components/CustomInput/Input.js";
import InfoArea from "components/InfoArea/InfoArea.js";
import Card from "components/Card/Card.js";
import CardBody from "components/Card/CardBody.js";

import styles from "./Styles/LoginPageStyles";

const API_URL = process.env.REACT_APP_API;
const useStyles = makeStyles(styles);

export default function ResetPasswordPage() {
  const classes = useStyles();
  const { token } = useParams();

  const [message, setMessage] = useState(null);
  const [reqError, setReqError] = useState(null);
  const [password, setPassword] = useState("");
  const [passVerify, setPassVerify] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);

  const requestReset = async () => {
    if (isSubmitting) return;

    setReqError(null);
    setMessage(null);

    const isEmpty = (v) => !v || v.toString().trim() === "";

    if ([password, passVerify].some(isEmpty)) {
      setReqError("Uno o más campos están vacíos.");
      return;
    }

    if (password !== passVerify) {
      setReqError("Las contraseñas no son iguales.");
      return;
    }

    setIsSubmitting(true);

    try {
      const req = await fetch(
        `/api/auth/reset-password/confirm/${token}`,
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ newPassword: password.trim() }),
        }
      );

      const resp = await req.json();

      if (!req.ok || resp.ok === false) {
        setReqError(resp.mensaje);
        return;
      }

      setMessage("Cambio de contraseña efectivo. Puede volver a iniciar sesión.");
    } catch (err) {
      setReqError(err.message);
      console.error(err);
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    requestReset();
  };

  return (
    <div className={classes.container}>
      <GridContainer justify="center">
        <GridItem xs={12} sm={12} md={10}>
          <Card className={classes.cardSignup}>
            <h2 className={classes.cardTitle}>Reestablecer contraseña</h2>

            <CardBody>
              <GridContainer justify="center" spacing={3}>
                <GridItem xs={12} sm={10} md={6}>
                  <InfoArea
                    title="Procedimiento"
                    description="Introduzca su nueva contraseña."
                    icon={Lock}
                    iconColor="primary"
                  />

                  <form className={classes.form} onSubmit={handleSubmit}>
                    <Input
                      passwordToggle
                      formControlProps={{
                        fullWidth: true,
                        className: classes.customFormControlClasses,
                      }}
                      inputProps={{
                        startAdornment: (
                          <InputAdornment
                            position="start"
                            className={classes.inputAdornment}
                          >
                            <Icon className={classes.inputAdornmentIcon}>
                              lock_outline
                            </Icon>
                          </InputAdornment>
                        ),
                        placeholder: "Nueva contraseña",
                        value: password,
                        onChange: (e) => setPassword(e.target.value),
                      }}
                    />

                    <Input
                      passwordToggle
                      formControlProps={{
                        fullWidth: true,
                        className: classes.customFormControlClasses,
                      }}
                      inputProps={{
                        startAdornment: (
                          <InputAdornment
                            position="start"
                            className={classes.inputAdornment}
                          >
                            <Icon className={classes.inputAdornmentIcon}>
                              lock_outline
                            </Icon>
                          </InputAdornment>
                        ),
                        placeholder: "Confirmar nueva contraseña",
                        value: passVerify,
                        onChange: (e) => setPassVerify(e.target.value),
                      }}
                    />

                    <Box mt={1} className={classes.center}>
                      <Typography
                        variant="body2"
                        style={{
                          color: "green",
                          minHeight: message ? 24 : 0,
                          wordBreak: "break-word",
                        }}
                      >
                        {message || ""}
                      </Typography>

                      <Typography
                        variant="body2"
                        style={{
                          color: "red",
                          minHeight: reqError ? 24 : 0,
                          wordBreak: "break-word",
                        }}
                      >
                        {reqError || ""}
                      </Typography>
                    </Box>

                    <Box mt={2} className={classes.center}>
                      <Button
                        round
                        color="primary"
                        type="submit"
                        disabled={isSubmitting}
                      >
                        Cambiar contraseña
                      </Button>
                    </Box>
                  </form>
                </GridItem>
              </GridContainer>
            </CardBody>
          </Card>
        </GridItem>
      </GridContainer>
    </div>
  );
}